import { z } from 'zod';
import { ORDER_SOURCE_SCHEMA, ProjectNumberSchema, TargetChannelSchema } from '@schuettflix/interfaces';
import { OrderConfigurationSchema } from '@/shared/models/ContextDataModel/interfaces/order/order-configuration.ts';
import { ProductConfigurationSchema } from '@/shared/models/ContextDataModel/interfaces/entities/product-configuration.ts';
import { CustomerInfoSchema } from '@/shared/models/ContextDataModel/interfaces/entities/customer-info.ts';

const PostOrderCustomerSchema = z.object({
    ...CustomerInfoSchema.shape,
    projectCode: ProjectNumberSchema,
});

const PostOrderProductConfigurationSchema = z.object({
    ...ProductConfigurationSchema.shape,
    positionProductId: z.string().nullable(),
    targetChannel: TargetChannelSchema,
});

export const PostOrderConfigurationRequestSchema = z.object({
    ...OrderConfigurationSchema.shape,
    productConfigurations: z.array(PostOrderProductConfigurationSchema),
    customer: PostOrderCustomerSchema,
    positionId: z.string().uuid().nullable(),
    positionNumber: z.string().nullable(),
    source: ORDER_SOURCE_SCHEMA,
});

export const PostOrderConfigurationResponseSchema = z.object({
    id: z.string(),
    humanReadableId: z.string().length(11),
});

export type PostOrderConfigurationRequest = z.infer<typeof PostOrderConfigurationRequestSchema>;
export type PostOrderConfigurationResponse = z.infer<typeof PostOrderConfigurationResponseSchema>;
